import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './services/auth.service';
import { StorageService } from './services/storage.service';
import { NomenclatureService } from './services/nomenclature.service';
import { VersionCheckService } from './services/version-check.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

	title = 'LWR-NEW';

	constructor(private router: Router, private nomService: NomenclatureService, private authService: AuthService, private storageService: StorageService, private versionCheck: VersionCheckService) { }

	ngOnInit(): void {
		// Следи за нов deploy — показва тостер „презареди" (без авто-reload,
		// за да не губим незаписани промени).
		this.versionCheck.start();
	}

	/** Флаг за тостера — true когато е деплойната нова версия. */
	get newVersionAvailable$() {
		return this.versionCheck.newVersionAvailable$;
	}

	reloadForUpdate(): void {
		this.versionCheck.reloadNow();
	}

	isUserLogged() {
		return this.authService.loggedIn();
	}

	get passwordMessage(): string | null {
		return this.storageService.getPasswordMessage();
	}

	dismissPasswordMessage() {
		this.storageService.removePasswordMessage(); // ако го пазиш в сториджа
	}
}
